import { render, staticRenderFns } from "./ConfirmPayForm.vue?vue&type=template&id=6c39ed5c&"
import script from "./ConfirmPayForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmPayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports